import {
    CREATE_JOB_CARD,
    DELETE_JOB_CARD,
    LIST_JOB_CARDS,
    UPDATE_JOB_CARD,
    VIEW_JOB_CARD,
    GET_CUSTOMER_LIST,
    GET_TECHNICIAN_LIST,
    GET_PRODUCT_LIST,
    UPDATE_CARD_STATUS
  } from "./ApiRoutes"; // Ensure these routes are defined in your ApiRoutes file
  import { authData } from "./services"; // Assuming authData is set up for API calls
  
  // Function to create a new job card
  export const createJobCard = async (data: object) => {
    const response = await authData.post(CREATE_JOB_CARD, data);
    return response?.data;
  };
  
  // Function to update an existing job card
  export const updateJobCard = async (id: string, data: object) => {
    const response = await authData.put(`${UPDATE_JOB_CARD}${id}`, data);
    return response?.data;
  };
  
  // Function to list all job cards
  export const listJobCards = async (data: object) => {
    const response = await authData.post(LIST_JOB_CARDS, data);
    return response?.data;
  };
  
  // Function to view a specific job card by ID
  export const viewJobCard = async (id: string) => {
    const response = await authData.get(`${VIEW_JOB_CARD}${id}`);
    return response.data.data;
  };
  
  // Function to delete a job card by ID
  export const deleteJobCard = async (id: string) => {
    const response = await authData.delete(`${DELETE_JOB_CARD}${id}`);
    return response?.data;
  };
  
  export const getCustomerList = async () => {
    const response = await authData.get(GET_CUSTOMER_LIST);
    return response.data;
    
  }
  
  export const getProductList = async () => {
    const response = await authData.get(GET_PRODUCT_LIST);
    
    return response.data;
  }
  
  export const getTechnicianList = async () => {
    const response = await authData.get(GET_TECHNICIAN_LIST);
    
    return response.data;
  }

  export const updateCardStatus = async (id: string, payload: { status: string }) => {
    const response = await authData.put(`${UPDATE_CARD_STATUS}${id}`, payload); 
    return response?.data; 
};